// extracted by mini-css-extract-plugin
export var filterIncDec = "_9t-0";
export var leftBorder = "_9t-1";
export var rightBorder = "_9t-2";
export var stringInput = "_9t-3";